import type { CycleStateCode, RegimeCode } from '../model/period';

export type DeclarableRegime = 'resico' | 'platec' | 'business';

export const REGIME_CODES: Record<DeclarableRegime, RegimeCode> = { resico: '626', platec: '625', business: '612' };

export const DECLARABLE_BY_CODE: Record<RegimeCode, DeclarableRegime> = { '626': 'resico', '625': 'platec', '612': 'business' };

export const isDeclarableRegime = (type: string): type is DeclarableRegime => type in REGIME_CODES;

export const ATTENTION_ORDER: CycleStateCode[] = [
	'listo_para_aprobar',
	'necesita_algo',
	'en_revision',
	'por_pagar',
	'sin_presentar',
	'presentando',
	'preparando',
	'mes_en_curso',
	'presentada',
	'pagada',
];
